import { ChangeDetectorRef, Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { OpenComplaintsPage } from '../open-complaints/open-complaints';
import { ClosedComplaintsPage } from '../closed-complaints/closed-complaints';
import { AllComplaintsPage } from '../all-complaints/all-complaints';
import { ComplaintsProvider } from '../../providers/complaints/complaints';
import { AddComplaintsPage } from '../add-complaints/add-complaints';
import { LoginProvider } from '../../providers/login/login';
import { TranslateService } from '@ngx-translate/core';
import { ToastProvider } from '../../providers/toast/toast';

@IonicPage()
@Component({
  selector: 'page-complaint-tabs',
  templateUrl: 'complaint-tabs.html',
})
export class ComplaintTabsPage {
  complaintCatagories= [];

  openPage = OpenComplaintsPage;
  closedPage = ClosedComplaintsPage;
  allPage = AllComplaintsPage;
  permissions: any;
  selRegistrationLogin  : any;
  
  index = 0;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private toast : ToastProvider,
    private complaintsProvider: ComplaintsProvider,
    private login: LoginProvider,
    private ref: ChangeDetectorRef){
      //ref.detach();
      // setInterval(() => {
      //     this.ref.detectChanges();
      // }, 500);
    if(navParams.get("index")){
      this.index = navParams.get("index");
    }


    this.selRegistrationLogin = localStorage.getItem('signup_login')

    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    }
else{
    complaintsProvider.getComplaintCategory().then(val=> {
      if(val.status == "success"){
        this.complaintCatagories = val.data;
      }
    });

    login.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
  }
  }

  openAddPage(){
    this.navCtrl.push(AddComplaintsPage, {
      categories: this.complaintCatagories
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/complaint-tabs/complaint-tabs.ts